import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import EmailTemplateEdit from './EmailTemplateEdit';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/jsonMessages';
import { slugToType } from '../emailTemplates/emailTemplateSlug';

export default async function action({ store, params, intl }) {
  const type = slugToType(params?.slug);
  const title = intl?.formatMessage(messages.emailTemplateEditPageTitle) ?? 'Email Templates - Edit';

  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  const adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
  const privileges = store.getState().listSettings && store.getState().listSettings.privileges;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  if (!restrictUrls('/siteadmin/email-templates', adminPrivileges, privileges)) {
    return { redirect: '/siteadmin' };
  }

  if (!type) {
    return { redirect: '/siteadmin/email-templates' };
  }



  return {
    title,
    component: <AdminLayout><EmailTemplateEdit type={type} title={title} /></AdminLayout>,
  };
}
